import { RequestParams, sendRequest } from '.';
import { ITransaction, ITransactionResponse } from '../types/transaction';

export const getBlockchainTransactionsList = (params: RequestParams, options: RequestInit = {}) => {
  const requestParams = {
    ...params,
    requestType: 'getBlockchainTransactions',
  };

  return sendRequest<ITransactionResponse>(requestParams, options).then((res) => res.transactions);
};

export const getAllTransactionApi = (params: RequestParams, options: RequestInit = {}) => {
  const requestParams = {
    ...params,
    requestType: 'getAllTransactions',
  };

  return sendRequest<ITransactionResponse>(requestParams, options).then((res) => res.transactions);
};

// search by fullHas, transaction (id),
export const getSingleTransactionApi = (params: RequestParams) => {
  return sendRequest<ITransaction>({
    requestType: 'getTransaction',
    ...params,
  });
};
